 /* global window:true */

import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import ReactGA from 'react-ga';

import BookSessionForm from '../forms/BookSessionForm';

class BookSessionPage extends Component {
    componentDidMount() {
        const { actions } = this.props;

        // load page data
        actions.getGeneralPageRequest({ name: 'book-session' });

        // set breadcrumb
        actions.setBreadcrumb([{ title: 'Book session' }]);

        // log analytics
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        const { actions, profile, pageContent } = this.props;

        return (
            <div className="contact-page-wrapper">
                <Helmet title="Book session" />
                <div className="container">
                    <div className="section-name index-2">
                        <h1>Book your free enterprise education session</h1>
                    </div>

                    <div className="row">
                        <div className="col-md-6 details-col">
                            <div contentEditable dangerouslySetInnerHTML={{ __html: pageContent }} />
                        </div>

                        <div className="col-md-6 contact-form-wrapper">
                            <BookSessionForm profile={profile} handleSubmit={actions.bookSessionRequest} />
                            <br />
                            <p>Once clicking <i>send message</i>, it may take a few moments to complete your request. Please do not leave or refresh this page until you have received confirmation that your submission was successful.</p>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

BookSessionPage.propTypes = {
    actions: PropTypes.object,
    profile: PropTypes.object,
    pageContent: PropTypes.any
};

export default BookSessionPage;



/** WEBPACK FOOTER **
 ** ./src/pages/BookSessionPage.js
 **/